import { ITEM_TYPES } from '@config/options.js'
import {
  COLLECTION_VIEW_ROUTE,
  GUIDE_VIEW_ROUTE,
  MOD_VIEW_ROUTE,
} from '@config/routeNames.js'

export const MOD_CARD = {
  resource: ITEM_TYPES.MOD,
  route: MOD_VIEW_ROUTE,
  footerComponent: 'ModCardFooter',
  footerProps: ['stats', 'date_added', 'date_updated', 'modfile'],
}

export const COLLECTION_CARD = {
  resource: ITEM_TYPES.COLLECTION,
  route: COLLECTION_VIEW_ROUTE,
  footerComponent: 'CollectionCardFooter',
  footerProps: ['stats', 'filesize'],
}

export const GUIDE_CARD = {
  resource: ITEM_TYPES.GUIDE,
  route: GUIDE_VIEW_ROUTE,
  footerComponent: 'GuideCardFooter',
  footerProps: ['stats', 'date_live', 'date_updated', 'description'],
}

// Stub for shared component support
export const GAME_CARD = {}
